import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { fullWidthBackgroundStyles } from '~/components/wrappers/IllustrationsBackground';

import {
    AcfAttributes,
    GlobalBlockOptions,
    AcfBackgroundColor,
    DefaultGlobalBlockOptions,
    DefaultAcfAttributes
} from '~/utilities/propTypes';
import { getSectionSpacing } from '~/utilities/spacing';
import { backgroundColors, zIndex } from '~/theme';

const Section = styled.section`
    position: relative;
    flex: 1;

    ${({ marginBottom }) => getSectionSpacing(marginBottom, 'margin-bottom')};
    ${({ padding }) => getSectionSpacing(padding, 'padding-top')};
    ${({ padding, paddingBottom }) =>
        getSectionSpacing(paddingBottom ?? padding, 'padding-bottom')};
    ${({ backgroundColor }) =>
        backgroundColor &&
        `
        &::before {
            ${fullWidthBackgroundStyles}
            z-index: ${zIndex.backgroundColor};
            background-color: ${backgroundColors[backgroundColor]};
        }
    `};
`;

const BlockSection = forwardRef(
    (
        {
            children,
            attributes = DefaultAcfAttributes,
            globalBlockOptions = DefaultGlobalBlockOptions,
            backgroundColor = '',
            padding = 'none',
            isSticky = false
        },
        ref
    ) => (
        <Section
            {...{
                backgroundColor,
                padding,
                isSticky,
                ref
            }}
            id={attributes.anchor}
            marginBottom={globalBlockOptions.marginBottom}
            className={attributes.className}
        >
            {children}
        </Section>
    )
);

BlockSection.propTypes = {
    children: PropTypes.node.isRequired,
    attributes: AcfAttributes,
    globalBlockOptions: GlobalBlockOptions,
    ...AcfBackgroundColor,
    padding: PropTypes.string,
    isSticky: PropTypes.bool
};

export default BlockSection;
